import React, {useEffect, useState} from 'react';
import {
   Image,
   SafeAreaView,
   StyleSheet,
   Text,
   TextInput,
   TouchableOpacity,
   View,
} from 'react-native';
import {
   ALLCOURSE,
   appBackground,
   primaryColor900,
   white,
   FONT_FAMILY_REGULAR,
} from '../../utils/utils';
import SearchView from '../dashboard/SearchView';
const BrowsesHeader = props => {
   const [selectedFilter, setSelectedFilter] = useState(ALLCOURSE);
   const [searchText, setSearchText] = useState('');

   const handleSearch = text => {
      setSearchText(text);
      // Perform search logic here using the entered text
   };

   return (
      <SafeAreaView style={styles.container}>
         <View style={styles.headerTopBackground}>
            <View
               style={{
                  flex: 1,
                  flexDirection: 'row',
                  alignItems: 'center',
               }}>
               <Image
                  source={require('../../assets/filter-search.png')}
                  style={{width: 16, height: 16, marginEnd: 4}}
               />
               <Text
                  style={{
                     textAlignVertical: 'center',
                     color: white,
                     fontSize: 12,
                     marginLeft: 10,
                     fontWeight: '500',
                     fontFamily: FONT_FAMILY_REGULAR,
                     marginEnd: 8,
                  }}>
                  Browse Courses
               </Text>
            </View>
            <Text
               style={{
                  color: white,
                  fontSize: 10,
                  fontWeight: '600',
                  fontStyle: 'italic',
               }}>
               {`${props.enrolledCount} Available Courses.`}
            </Text>
         </View>
         <View style={styles.headerSearchBackgroud}>
            <SearchView
               onClearText={() => {
                  props.onClearText();
               }}
               onSearch={text => {
                  props.onSearch(text);
               }}
            />
         </View>
      </SafeAreaView>
   );
};

const styles = StyleSheet.create({
   container: {backgroundColor: appBackground},
   headerSearchBackgroud: {
      backgroundColor: '#001D4E',
      /* paddingHorizontal: 16,
      paddingVertical: 20, */
      padding: 16,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
   },
   headerTopBackground: {
      backgroundColor: '#001231',
      paddingHorizontal: 16,
      paddingVertical: 10,
      flexDirection: 'row',
      alignItems: 'center',
   },
   headerBackground: {
      backgroundColor: '#001231',
      justifyContent: 'space-between',
      flexDirection: 'row',
      alignItems: 'center',
      width: '100%',
   },
   headerBottomBackground: {
      backgroundColor: primaryColor900,
      paddingHorizontal: 16,
      paddingVertical: 6,
      flexDirection: 'row',
      alignItems: 'center',
   },
});

export default BrowsesHeader;
